import { render, staticRenderFns } from "./Curation.vue?vue&type=template&id=2bfedc41&scoped=true"
import script from "./Curation.vue?vue&type=script&lang=js"
export * from "./Curation.vue?vue&type=script&lang=js"
import style0 from "./Curation.vue?vue&type=style&index=0&id=2bfedc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfedc41",
  null
  
)

export default component.exports